import { Component, Input } from '@angular/core';
import {  NbDialogRef } from '@nebular/theme';
import { FormControl, FormGroup, Validators } from '@angular/forms';import { ServiceComponent, ServiceComponentDTO } from '../../../../Models/serviceComponent/serviceComponent-dto';

@Component({
  selector: 'ngx-update-service-component-from',
  templateUrl: './update-service-component-from.component.html',
  styleUrl: './update-service-component-from.component.scss'
})
export class UpdateServiceComponentFromComponent {
  public constructor(protected ref: NbDialogRef<UpdateServiceComponentFromComponent>){}

  @Input() product : ServiceComponent;
  private initialFormValue: any = {}; // Store the initial form values

  form = new FormGroup({
    name: new FormControl('', Validators.required),
    tag: new FormControl('', Validators.required),
    image: new FormControl('', Validators.required),
    imageVariable: new FormControl('', Validators.required),
  });

  ngOnInit(){
    //initialize form values
    if(this.product){
      this.form.patchValue({
        name: this.product.name || '',
        tag: this.product.tag || '',
        image: this.product.image || '',
        imageVariable: this.product.imageVariable || '',
      })
    }
    // Save the initial values to compare later
    this.initialFormValue = this.form.getRawValue();
  }

  submit(){
    const currentFormValue = this.form.getRawValue();

    // Compare the initial and current form values
    if (JSON.stringify(this.initialFormValue) === JSON.stringify(currentFormValue)) {
      this.ref.close(); // Close the form without sending a request
      return;
      }
    // TODO add validation for fields
    // if(this.form.valid){
    else{
      this.ref.close(this.form.value);
    }
    // else {
    //   this.ref.close()
    // }
  }

  cancel(){
    this.ref.close();
  }
}
